import React from 'react';
import { Provider } from 'react-redux';
import configureStore from './src/configure-store';

export default ({ element }) => {
  const startingState = {};
  const store = configureStore(startingState);
  return <Provider {...{ store }}>{element}</Provider>;
};
